import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl, appendToRmaBillingApiUrl } from '@rma/common-ui-ng/util';
import { httpParamMapper } from '@rma/generic/util/http';
import {
  ProductFilter,
  ProductModel,
  ProductType,
  ProductUserType,
  ProductUserTypeGrouping,
  SubscriptionModel,
} from '@rma/subscriptions/public-api/da-billing-context';
import { Observable } from 'rxjs';
import { SubscriptionSummary } from '../domain/current-subscription.model';
import { SubscriptionPlanAccess } from '../domain/subscription-plan-access.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);
  private readonly rmaBillingApiUrl = inject(appendToRmaBillingApiUrl);

  public getCurrentAgentSubscriptionSummary(): Observable<SubscriptionSummary> {
    const url = this.rmaApiUrl('Agents/Me/Subscription/summary');

    return this.httpClient.get<SubscriptionSummary>(url);
  }

  public getCurrentAgencySubscriptionSummary(agencyCode: string): Observable<SubscriptionSummary> {
    const url = this.rmaApiUrl(`Agencies/Code-${agencyCode}/Subscription/Summary`);

    return this.httpClient.get<SubscriptionSummary>(url);
  }

  public getCurrentSubscription(
    productUserType: ProductUserType,
    productUserTypeGrouping: ProductUserTypeGrouping,
    code: string,
  ): Observable<SubscriptionModel> {
    const url = this.rmaBillingApiUrl(`${productUserType}/${productUserTypeGrouping}-${code}/Subscriptions`);

    return this.httpClient.get<SubscriptionModel>(url);
  }

  public getProducts(filter?: ProductFilter): Observable<ProductModel[]> {
    const url = this.rmaBillingApiUrl('Products');

    const params = { params: httpParamMapper(filter) };

    return this.httpClient.get<ProductModel[]>(url, params);
  }

  public getProductsForUser(
    productUserType: ProductUserType,
    productUserTypeGrouping: ProductUserTypeGrouping,
    code: string,
    productType: ProductType,
  ): Observable<ProductModel[]> {
    const url = this.rmaBillingApiUrl(`${productUserType}/${productUserTypeGrouping}-${code}/${productType}/Products`);

    return this.httpClient.get<ProductModel[]>(url);
  }

  public getCurrentAgentAccess(): Observable<SubscriptionPlanAccess> {
    const url = this.rmaApiUrl('Agents/Me/Subscription/Access');

    return this.httpClient.get<SubscriptionPlanAccess>(url);
  }

  public getAgencyAccess(agencyCode: string): Observable<SubscriptionPlanAccess> {
    const url = this.rmaApiUrl(`Agencies/Code-${agencyCode}/Subscription/Access`);

    return this.httpClient.get<SubscriptionPlanAccess>(url);
  }
}
